import React from 'react'
import GenericPullAndPushToolView from '../GenericPullAndPushToolView'
import QwietAIConfigListing from './QwietAIConfigListing'
import QwietAICredentialsForm from './QwietAICredentialsForm'

export default function QwietAIPullAndPushView(props) {
    return (
        <GenericPullAndPushToolView 
            {...props}
            PullCredentialForm={QwietAICredentialsForm}
            PullConfigListingView={QwietAIConfigListing}
        />
    )
}
